// Presentation copies share the reveal portrait without duplicating IDs or actions.
export function createCharacterPresentation(character, container) {
  const overlay = document.createElement('div');
  overlay.id = `reveal_${character.id}`;
  overlay.dataset.turboPermanent = '';
  overlay.className = 'character_wrapper game-screen-character-reveal';
  overlay.setAttribute('aria-hidden', 'true');
  overlay.inert = true;
  overlay.setAttribute('popover', 'manual');
  const card = character.querySelector('.character.card').cloneNode(true);
  // No duplicate Turbo IDs or interactive behavior. Restore icon loading and
  // text fitting, since a hidden card's inline font size may be tiny.
  for (const element of [card, ...card.querySelectorAll('*')]) {
    const iconUrl = element.getAttribute('data-condition-icon-url-value');
    const title = element.getAttribute('data-bs-original-title');
    if (title) element.setAttribute('title', title);
    for (const attribute of [...element.attributes]) {
      if (attribute.name === 'id' || attribute.name.startsWith('data-')) element.removeAttribute(attribute.name);
    }
    // Copies may be made before the source's asynchronous SVG load finishes.
    if (iconUrl) {
      element.setAttribute('data-controller', 'condition-icon');
      element.setAttribute('data-condition-icon-url-value', iconUrl);
    }
  }
  const name = card.querySelector('.character_name');
  const content = name?.querySelector('.character_name__text');
  if (content) {
    name.dataset.controller = 'fittext';
    name.dataset.fittextMultilineValue = 'true';
    content.dataset.fittextTarget = 'content';
    content.style.fontSize = '';
  }
  overlay.append(card);
  // The top layer keeps viewport coordinates independent of character placement,
  // while DOM ownership and cleanup remain inside the character component.
  container.append(overlay);
  overlay.showPopover();
  return overlay;
}
